import TLanding from './index.vue';

TLanding.install = app => {
  app.component(TLanding.name, TLanding);
};

export default TLanding;
